import {
  IdentitySegments,
  identityToUser,
  integrateCombinedConfigCat,
  isValidObject,
  requireDefined,
  SegmentManager,
  SegmentsToUser,
} from '@nutrien/ddc-fe-feature-flags-react';
import { isString } from 'radash';

import { applyFeatureFlagTypes, FeatureFlags, isFeatureFlags } from '@/featureFlags/FeatureFlags';

export interface MinesightSegments extends IdentitySegments {
  mineSightBorer: string;
  site: string;
  siteId: string;
  version: string;
}

export const sdkKeys = requireDefined(import.meta.env.VITE_CONFIGCAT_SDK_KEY).split(',');

export const unknownUser: Readonly<MinesightSegments> = {
  email: 'unknown@example.com',
  userId: 'unknown-user-id',
  mineSightBorer: 'unknown-mine-sight-borer',
  site: 'unknown-site',
  siteId: 'unknown-site-id',
  version: 'unknown-version',
};

export const segmentManager: SegmentManager<MinesightSegments> = {
  eventTarget: document,
  segments: unknownUser,
};

const minesightIdentityToUser: SegmentsToUser<MinesightSegments> = (
  segments: MinesightSegments,
) => ({
  ...identityToUser(segments),
  custom: {
    mineSightBorer: segments.mineSightBorer,
    site: segments.site,
    siteId: segments.siteId,
    version: segments.version,
  },
});

function isMinesightIdentitySegments(value: unknown): value is MinesightSegments {
  return isValidObject<MinesightSegments>(
    {
      email: isString,
      userId: isString,
      mineSightBorer: isString,
      site: isString,
      siteId: isString,
      version: isString,
    },
    value,
  );
}

export const configCat = integrateCombinedConfigCat<FeatureFlags, MinesightSegments>(
  sdkKeys,
  isFeatureFlags,
  applyFeatureFlagTypes,
  segmentManager,
  minesightIdentityToUser,
  isMinesightIdentitySegments,
);
